module.exports = __webpack_public_path__ + "img/happy.e9a03be9.png";